import { render, staticRenderFns } from "./component-city.vue?vue&type=template&id=051f7136"
import script from "./component-city.vue?vue&type=script&lang=js"
export * from "./component-city.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports